import { render } from "./TheBBCLower.vue?vue&type=template&id=164bef3b"
import script from "./TheBBCLower.vue?vue&type=script&lang=js"
export * from "./TheBBCLower.vue?vue&type=script&lang=js"
script.render = render

export default script